import axios from "axios";

// Build-time API base. The API is served under /api.
//  - single-service (FastAPI serves the build): REACT_APP_API_BASE="/api"
//  - two-service: REACT_APP_API_BASE="https://your-backend.up.railway.app/api"
//  - local `npm start`: defaults to the local dev server below.
export const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000/api";

export const TOKEN_KEY = "sage_token";
export const USER_KEY  = "sage_user";

// The session lives in sessionStorage (per-tab), not localStorage — so opening
// the app in a new tab always starts at the login page instead of inheriting
// another tab's login. `store` is the single source of truth for the session.
export const store = window.sessionStorage;

// One-time cleanup: drop any old localStorage session from before this change,
// so returning visitors also land on the login page.
try {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
} catch (e) { /* ignore */ }

export const api = axios.create({ baseURL: API_BASE });

// Attach JWT on every request.
api.interceptors.request.use((config) => {
  const token = store.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 anywhere, clear the session.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      store.removeItem(TOKEN_KEY);
      store.removeItem(USER_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fmtINR = (n) =>
  "₹" +
  Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return d; }
};
